import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const HeaderContainer = styled.div`
    height: 70px;
    width: 100%;
    background: ${({ theme }) => theme.palette.primary.dark};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 8px;
    max-width: 100vw;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 24px;
        padding: 0 40px;
    }
`;

export const MobileNavIcon = styled(IconButton)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;